import React, { useContext, useMemo } from 'react';
import _ from 'underscore';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { Collapse, TextTitle, useCollapseState, ValidatedPanel, collapseExpander, getPanelErrorProps } from '@bingads-webui-campaign/wizard-jumbo-card';
import { ValidatedLegacyDateSetting, getDateSettingDetails } from '@bingads-webui-campaign/date-setting';
import { StartEndDateImg } from '@bingads-webui-campaign-react/perf-max-step-wizard';

export const MoreSettingsSection = ({
  assetGroup,
  campaignTimeZone,
}) => {
  const i18n = useContext(I18nContext);

  const [
    allMoreSettingsSections,
    moreSettingsExpandedSections,
    setMoreSettingsExpandedSections,
  ] = useCollapseState(
    ['start-end-dates'] /* all sections */,
    ['start-end-dates'] /* initially expanded sections */
  );

  const moreSettingsExpand = useMemo(
    () => collapseExpander({ setActiveKeys: setMoreSettingsExpandedSections }),
    [setMoreSettingsExpandedSections]
  );

  const startDate = useMemo(() => (assetGroup.data && assetGroup.data.StartDate ? assetGroup.data.StartDate : new Date()), [assetGroup.data]);

  const moreSettingsSection = useMemo(() => (
    <div className={classNames('more-settings-section')}>
      <h6 className="page-title">{i18n.getString(_TL_('MORE SETTINGS'))}</h6>
      <Collapse allPanelItems={allMoreSettingsSections} checkItems skipItemsTypeCheck activeKeys={moreSettingsExpandedSections} setActiveKeys={setMoreSettingsExpandedSections}>
        <ValidatedPanel
          key="start-end-dates"
          title={<TextTitle
            titleKey={_TL_('Start and end dates')}
            details={getDateSettingDetails(i18n, startDate)}
            icon={StartEndDateImg}
          />}
          attentionBeaconProps={{ getExtraProps: getPanelErrorProps }}
          actuationProps={{
            expand: moreSettingsExpand,
            expandKey: 'start-end-dates',
          }}
        >
          <ValidatedLegacyDateSetting
            i18n={i18n}
            validationProps={{
              data: {
                StartDate: startDate,
                EndDate: assetGroup?.data?.EndDate,
                TimeZone: campaignTimeZone,
                isCreate: !assetGroup?.data?.Id,
              },
              initialValue: {
                StartDate: startDate,
                EndDate: (_.isNull(assetGroup?.data?.EndDate) || _.isUndefined(assetGroup?.data?.EndDate)) ? null : assetGroup.data.EndDate,
              },
            }}
          />
        </ValidatedPanel>
      </Collapse>
    </div>
  ), [i18n, allMoreSettingsSections, moreSettingsExpandedSections, setMoreSettingsExpandedSections, startDate, moreSettingsExpand, assetGroup.data?.EndDate, assetGroup.data?.Id, campaignTimeZone]);

  return moreSettingsSection;
};

MoreSettingsSection.propTypes = {
  assetGroup: PropTypes.shape({}).isRequired,
  campaignTimeZone: PropTypes.string.isRequired,
};
